var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      ref: _vm.dialogRef,
      attrs: { id: "general-form-wrapper", "md-click-outside-to-close": false },
      on: { close: _vm.handleDialogClose }
    },
    [
      _c("md-dialog-title", [_vm._v("Rental price")]),
      _vm.openDialog
        ? _c(
            "md-dialog-content",
            [
              _c("rental-pricing-form", {
                attrs: { price: _vm.price },
                on: { "price-selected": _vm.handlePriceSelected }
              }),
              _c("playlist-selector", {
                attrs: {
                  multiple: true,
                  value: _vm.mediaItemSelected.playlists
                },
                on: { input: _vm.selectedPlaylist }
              }),
              _c("md-chips", {
                attrs: {
                  id: "input-chips",
                  "md-max": 15,
                  "md-input-placeholder": "Tags..."
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(chip) {
                        return [_c("span", [_vm._v(_vm._s(chip.value))])]
                      }
                    }
                  ],
                  null,
                  false,
                  3226392169
                ),
                model: {
                  value: _vm.tags,
                  callback: function($$v) {
                    _vm.tags = $$v
                  },
                  expression: "tags"
                }
              }),
              _c(
                "div",
                [
                  _c("div", { staticClass: "data-container" }, [
                    _c("p", { staticClass: "md-headline" }, [
                      _vm._v("Ad Breaks")
                    ]),
                    _c("p", { staticClass: "video-duration" }, [
                      _vm._v("Video duration: " + _vm._s(_vm.duration))
                    ])
                  ]),
                  _c("media-items-roku-ad-breaks", {
                    attrs: {
                      formSubmitted: _vm.formSubmitted,
                      mediaItem: _vm.mediaItemSelected
                    }
                  })
                ],
                1
              ),
              _c("Loader", { attrs: { loading: _vm.loading, size: 50 } }),
              !_vm.loading
                ? _c(
                    "div",
                    { staticClass: "btn-container" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary md-raised",
                          on: {
                            click: function($event) {
                              return _vm.saveData()
                            }
                          }
                        },
                        [_vm._v("Save")]
                      ),
                      _c(
                        "md-button",
                        {
                          staticClass: "cancel-btn md-raised",
                          on: {
                            click: function($event) {
                              return _vm.closeDialog()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a3306fb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a3306fb","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaItem/RentalPriceDialog.vue
// module id = 903
// module chunks = 0